import {
    getPlanToDisplay,
    getProductPill,
    getLearnMoreLinkHref,
} from 'shells/billing/add-ons/helpers';
import {PlanPrice} from 'shells/billing/plan-price';
import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {Button} from 'shells/button/button';
import {Card} from 'shells/card/card';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {Body} from 'shells/typography/body';

import type {GetAvailablePlans_recurlyAvailablePlans_quotes as Quotes} from 'nutshell-graphql-types';

import styles from './quotes-promo-modal.module.css';

interface Props {
    quotesAddOn: Quotes | null | undefined;
    onClose: () => void;
    onContinue: () => void;
}

export function QuotesPromoOfferStep(props: Props) {
    const planToDisplay = props.quotesAddOn
        ? getPlanToDisplay(props.quotesAddOn.plans, null, props.quotesAddOn.defaultCode)
        : null;

    return (
        <div className={styles.wrapper}>
            <div className={styles['main-content']}>
                <Stack spacing={8}>
                    <Body isBold={true} size='xlarge' color='dark' useDoyle={true}>
                        Quotes & Invoices free
                        <br />
                        for 3 months
                    </Body>
                    <Body size='large'>
                        Create, send and track sales documents directly from Nutshell
                    </Body>
                </Stack>
                {planToDisplay ? (
                    <div className='pt-16'>
                        <Card
                            hasBorder={true}
                            hasShadow={true}
                            fitHeight={true}
                            overflowVisible={true}
                        >
                            <div className='flex flex-dir-col gap-16 pos-relative pad-24'>
                                <div className={styles.pill}>
                                    {getProductPill(planToDisplay.product)}
                                </div>
                                <Stack spacing={2}>
                                    <PlanPrice
                                        price={planToDisplay.price}
                                        stickerPrice={planToDisplay.stickerPrice}
                                        justify='start'
                                    />
                                    <Body color='dark' size='small'>
                                        per month
                                    </Body>
                                </Stack>
                                <BulletedList
                                    size='small'
                                    bullets={planToDisplay.planHighlights.map((highlight) => (
                                        <Body key={highlight}>{highlight}</Body>
                                    ))}
                                    marginBottom={0}
                                />
                            </div>
                        </Card>
                    </div>
                ) : (
                    <LoadingPage padding={108} fullHeight={false} />
                )}
            </div>
            <div className={styles.footer}>
                <Button variant='text-secondary' onClick={props.onClose}>
                    Close
                </Button>
                <div className='flex align-center gap-16'>
                    <Link href={getLearnMoreLinkHref('QUOTES')} newTab={true} variant='primary'>
                        Learn more
                    </Link>
                    <Button variant='primary' onClick={props.onContinue}>
                        Continue
                    </Button>
                </div>
            </div>
        </div>
    );
}
